import { GzLabeledContentWebComponent } from './component/GzLabeledContentWebComponent';
import { WEB_COMPONENT_GZ_LABELED_CONTENT } from '../../webcomponents.constants';

export { GzLabeledContentWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_LABELED_CONTENT, GzLabeledContentWebComponent);
